import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import useScreenSize from "hooks/use-screen-size";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { FC } from "react";

import styles from "./styles.module.scss";

export interface Props {
  title: string;
  description: string;
  cta: { reads: string; to: string };
  image: string;
}

const Heading: FC<Props> = ({ title, description, cta, image }) => {
  const router = useRouter();

  const { isResponsive, isMobile } = useScreenSize();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <div className={styles.top}>
        <div className={styles.leftPanel}>
          <Label
            variant="s-capitalized"
            color="supplemental"
            className={styles.becomeAVendor}
          >
            Become a vendor
          </Label>
          <div className={styles.titleWrapper}>
            <Label
              className={styles.title}
              useMarkdown={!isResponsive}
              variant="h"
              color="lightPrimary"
            >
              {title}
            </Label>
          </div>
          <div className={styles.subtitleWrapper}>
            <Label
              className={styles.subtitle}
              useMarkdown={!isResponsive}
              variant="s"
              color="lightPrimary"
            >
              {description}
            </Label>
          </div>
          <Button onClick={() => router.push(cta.to)} variant="cta">
            {cta.reads}
          </Button>
        </div>
        <div className={styles.rightPanel}>
          <Image
            alt=""
            src={image}
            layout="fixed"
            width={isResponsive ? (isMobile ? 250 : 300) : 450}
            height={isResponsive ? (isMobile ? 250 : 300) : 450}
          />
        </div>
      </div>
    </Content>
  );
};

export default Heading;
